import { createSlice } from "@reduxjs/toolkit";
import {
  sendContactMessage,
  getContactMessages,
  getContactMessageById,
  deleteContactMessage,
} from "./thunk";

const initialState = {
  messages: [],
  selectedMessage: null,
  loading: false,
  error: null,
  totalCount: 0,
  totalPages: 0,
  currentPage: 1,
};

const ContactSlice = createSlice({
  name: "contact",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // ---------------- SEND MESSAGE (PUBLIC) ----------------
    builder
      .addCase(sendContactMessage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(sendContactMessage.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(sendContactMessage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || action.error.message;
      });

    // ---------------- GET ALL (ADMIN) ----------------
    builder
      .addCase(getContactMessages.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getContactMessages.fulfilled, (state, action) => {
        state.loading = false;
        state.messages = action.payload.data || [];
        // console.log(action.payload);
        state.totalCount = action.payload.responseDetails?.totalCount || 0;
        state.totalPages =
          action.payload.responseDetails?.pagination?.totalPages || 1;
        state.currentPage =
          action.payload.responseDetails?.pagination?.currentPage || 1;
      })
      .addCase(getContactMessages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || action.error.message;
      });

    // ---------------- GET ONE (ADMIN) ----------------
    builder
      .addCase(getContactMessageById.fulfilled, (state, action) => {
        state.selectedMessage = action.payload;
      })
      .addCase(getContactMessageById.rejected, (state, action) => {
        state.error = action.payload?.message || action.error.message;
      });

    // ---------------- DELETE (ADMIN) ----------------
    builder
      .addCase(deleteContactMessage.fulfilled, (state, action) => {
        state.messages = state.messages.filter(
          (msg) => msg.id.toString() !== action.payload.id.toString(),
        );
      })
      .addCase(deleteContactMessage.rejected, (state, action) => {
        state.error = action.payload?.message || action.error.message;
      });
  },
});

export default ContactSlice.reducer;
